export const environment = {
    production: false,
    lang: ['fr'],
    apiHost: 'https://staging.mct.monsieursloop.com',
    apiBasePath: '/api',
    apiPublicBasePath: '/public',
    apiSuffix: '',
    prefixAsset: '',
    gtmId: 'G-2ZSNYM94R1',
    apiVideoHost: 'https://ws.api.video',
    // relay can't be used because of 421 issue
    apiVideoHostUpload: 'https://ws.api.video',
    apiVideoCustomDomain: ''
};
